import TrustedCard from './TrustedCard';
export default TrustedCard;